import PropTypes from 'prop-types'
import React from 'react'
import { useRouter } from 'next/router'
import { removeDomainFromLink } from 'utils'

const MyLink = ({ id, className = '', children, dataGa = '', style, href = '', onClick = () => {}, target }) => {
  const router = useRouter()

  return (
    <a href={removeDomainFromLink(href, router.query.appId, router.asPath)} id={id} data-ga={dataGa} onClick={onClick} style={style} className={className} target={target}>
      {children}
    </a>
  )
}

MyLink.propTypes = {
  children: PropTypes.any,
  className:PropTypes.string,
  dataGa: PropTypes.string,
  id: PropTypes.string,
  href: PropTypes.string,
  onClick: PropTypes.any,
  style: PropTypes.object,
  target: PropTypes.any,
}

export default MyLink
